var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.articles.length > 0
    ? _c("div", { staticClass: "profile-articles m-t-3" }, [
        _c("h2", {
          staticClass: "no-border no-margin new-headers",
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("profile.in_magazine", {
                profile_title: _vm.profile.profile_title,
              })
            ),
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "associated-articles-carousel" },
          [
            _c(
              "vueper-slides",
              {
                staticClass: "no-shadow",
                attrs: {
                  "fixed-height": true,
                  gap: 1,
                  slideMultiple: true,
                  bullets: false,
                  "arrows-outside": false,
                  "visible-slides": _vm.visibleSlides,
                  touchable: false,
                  breakpoints: _vm.breakpoints,
                  disableArrowsOnEdges: true,
                  autoplay: false,
                },
              },
              _vm._l(_vm.articles, function (article, index) {
                return _c("vueper-slide", {
                  key: index,
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _vm.articles.length < 3
                              ? _c("div", { staticClass: "row" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: article.url,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "col-md-6" }, [
                                        _c("div", {
                                          staticClass:
                                            "wa-responsive-image--h180 m-b-1",
                                          style:
                                            "background-image: url(" +
                                            _vm.debugDomain +
                                            article.page_elements[0]
                                              .cms_page_element_image.path +
                                            ")",
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-6" }, [
                                        _c(
                                          "h5",
                                          {
                                            staticClass:
                                              "font-sans bold no-border",
                                          },
                                          [_vm._v(_vm._s(article.title))]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "teaser-text",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              article.page_elements[1].text
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass:
                                            "wa-arrow wa-arrow-medium",
                                        }),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              article.magazine.domain
                                                .capitalized_name
                                            ) +
                                            "\n\t\t\t\t\t\t\t"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.articles.length > 2
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: article.url,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "wa-responsive-image--h180 m-b-1",
                                        style:
                                          "background-image: url(" +
                                          _vm.debugDomain +
                                          article.page_elements[0]
                                            .cms_page_element_image.path +
                                          ")",
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "font-sans bold no-border",
                                        },
                                        [_vm._v(_vm._s(article.title))]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "teaser-text",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            article.page_elements[1].text
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "wa-arrow wa-arrow-medium",
                                      }),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            article.magazine.domain
                                              .capitalized_name
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }